import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './styles/index.css';
import App from './App';
import SharedAccess from './pages/SharedAccess';
import LegalNotice from './pages/LegalNotice';
import ErrorBoundary from './components/ErrorBoundary';
import { ToastProvider } from './components/Toast';
import { AuthProvider } from './contexts/AuthContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <ToastProvider>
        <AuthProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/shared/:token" element={<SharedAccess />} />
              <Route path="/legal" element={<LegalNotice notice="legal" />} />
              <Route path="/privacy" element={<LegalNotice notice="privacy" />} />
              <Route path="/terms" element={<LegalNotice notice="terms" />} />
              <Route path="/hipaa-notice" element={<LegalNotice notice="hipaa" />} />
              <Route path="/*" element={<App />} />
            </Routes>
          </BrowserRouter>
        </AuthProvider>
      </ToastProvider>
    </ErrorBoundary>
  </React.StrictMode>
);
